import React from 'react';
import { LegalDocumentPage } from './LegalDocumentPage';
import { PRIVACY_POLICY } from './legalContent';

export const PrivacyPolicyPage: React.FC = () => <LegalDocumentPage document={PRIVACY_POLICY} />;
